import React from 'react';
import Image from 'next/image';
import cN from 'classnames';
import { CatalogItem } from '@/shared/types/catalog';
import { PDPContentTab } from '@/shared/types/sourcing-marketplace';
import {
  PDP_DESCRIPTION_SECTION_ID,
  PDP_REVIEWS_SECTION_ID,
  PDP_SIMILAR_PRODUCTS_SECTION_ID,
  PDP_SUPPLIER_CAPABILITIES_SECTION_ID,
} from '@/shared/constants/sourcing-marketplace';
import { scrollTo } from '@/shared/utils/utils';
import SupplierOverview from '../SupplierOverview';
import { isEmpty } from 'lodash-es';
import './index.less';

interface IProps {
  product: CatalogItem;
  selectedTab: PDPContentTab;
  setSelectedTab: (tab: PDPContentTab) => void;
}

const NavigationPanel = ({ product, selectedTab, setSelectedTab }: IProps) => {
  const renderTab = (name: string, tab: PDPContentTab, sectionId: string) => {
    return (
      <div
        className={cN('tab', { selected: tab === selectedTab })}
        onClick={() => {
          setSelectedTab(tab);
          scrollTo(sectionId);
        }}
      >
        <Image src="/images/sourcing/selected-tab.svg" width={12} height={12} alt="tab" />
        <span>{name}</span>
      </div>
    );
  };

  return (
    <div className="navigation-panel">
      <SupplierOverview product={product} />
      <div className="section bordered">
        <div className="steps">
          {renderTab('Product description', PDPContentTab.PRODUCT_DESCRIPTION, PDP_DESCRIPTION_SECTION_ID)}
          {!isEmpty(product.catalogCompany?.productionCustomizations) &&
            renderTab(
              'Supplier capabilities',
              PDPContentTab.SUPPLIER_CAPABILITIES,
              PDP_SUPPLIER_CAPABILITIES_SECTION_ID,
            )}
          {renderTab('Similar products', PDPContentTab.SIMILAR_PRODUCTS, PDP_SIMILAR_PRODUCTS_SECTION_ID)}
          {renderTab('Reviews', PDPContentTab.REVIEWS, PDP_REVIEWS_SECTION_ID)}
        </div>
      </div>
    </div>
  );
};

export default NavigationPanel;
